import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import ProtectedRoute from "./ProtectedRoute";
import Home from "./Home";
import Dashboard from "./Dashboard";
import TenderDetails from "./TenderDetails";
import Login from "./Login";
import Register from "./Register";
import UserManagement from "./UserManagement";
import TeamManagement from "./TeamManagement";
import TeamDirectory from "./TeamDirectory";
import SubscriptionManagement from "./SubscriptionManagement";
import VendorManagement from "./VendorManagement";
import AuditLog from "./AuditLog";
import "./styles.css";
import "./auth-management.css";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Protected Routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/tender/:id" 
            element={
              <ProtectedRoute>
                <TenderDetails />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/users" 
            element={
              <ProtectedRoute requiredRole="admin">
                <UserManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/teams" 
            element={
              <ProtectedRoute requiredRole="manager">
                <TeamManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/subscription" 
            element={
              <ProtectedRoute>
                <SubscriptionManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/vendors" 
            element={
              <ProtectedRoute>
                <VendorManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/audit-log" 
            element={
              <ProtectedRoute requiredRole="manager">
                <AuditLog />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/team-directory" 
            element={
              <ProtectedRoute>
                <TeamDirectory />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
